import { solution, unicodeSplit } from './words'
import { WORD_LENGTH } from '../constants/settings'

export type CharStatus = 'absent' | 'otherword' | 'present' | 'correct'

export const getStatuses = (
  guesses: string[]
): { [key: string]: CharStatus } => {
  const charObj: { [key: string]: CharStatus } = {}
  const splitSolution = unicodeSplit(solution)

  guesses.forEach((word) => {
    unicodeSplit(word).forEach((letter, i) => {
      if (!splitSolution.includes(letter)) {
        // make status absent
        return (charObj[letter] = 'absent')
      }

      if (letter === splitSolution[i]) {
        //make status correct
        return (charObj[letter] = 'correct')
      }

      if (charObj[letter] !== 'correct') {
        var word = solution.substring(
          i - (i % WORD_LENGTH),
          i + WORD_LENGTH - (i % WORD_LENGTH)
        )
        var wordsplit = unicodeSplit(word)
        if (wordsplit.includes(letter)) {
          return (charObj[letter] = 'otherword')
        }

        //make status present
        if (charObj[letter] !== 'otherword') {
          return (charObj[letter] = 'present')
        }
      }
    })
  })

  return charObj
}

export const getGuessStatuses = (guess: string): CharStatus[] => {
  const splitSolution = unicodeSplit(solution)
  const splitGuess = unicodeSplit(guess)

  const solutionCharsTaken = splitSolution.map((_) => false)

  const statuses: CharStatus[] = Array.from(Array(guess.length))

  // handle all correct cases first
  splitGuess.forEach((letter, i) => {
    if (letter === splitSolution[i]) {
      statuses[i] = 'correct'
      solutionCharsTaken[i] = true
      return
    }
  })
  splitGuess.forEach((letter, i) => {
    if (statuses[i]) return

    if (!splitSolution.includes(letter)) {
      // handles the absent case
      statuses[i] = 'absent'
      return
    }
    // now look for letters in the same word
    const indexOfSameWordChar = splitSolution.findIndex(
      (x, index) =>
        x === letter &&
        !solutionCharsTaken[index] &&
        Math.floor(index / 5) === Math.floor(i / 5)
    )

    if (indexOfSameWordChar > -1) {
      statuses[i] = 'present'
      //console.debug('setting status[%d] to present because solution[%d] matches %s',i,indexOfSameWordChar,letter)
      solutionCharsTaken[indexOfSameWordChar] = true
      return
    }
  })

  splitGuess.forEach((letter, i) => {
    if (statuses[i]) return

    // now look for letters in the same word
    const indexOfOtherWordChar = splitSolution.findIndex(
      (x, index) =>
        x === letter &&
        !solutionCharsTaken[index] &&
        Math.floor(index / 5) !== Math.floor(i / 5)
    )

    if (indexOfOtherWordChar > -1) {
      //console.debug('setting status[%d] to otherword because solution[%d] matches %s',i, indexOfOtherWordChar,letter)
      statuses[i] = 'otherword'
      solutionCharsTaken[indexOfOtherWordChar] = true
      return
    }

    statuses[i] = 'absent'
    return
  })

  return statuses
}
